import type React from 'react';
import { useCallback } from 'react';

import { SettingsRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import { AnalyticsIdentityBridge, AnalyticsPageTrackingBridge } from '@ragu-components/ord-analytics';
import { AppBar, UserMenu, UserMenuItem } from '@ragu-components/ord-components';
import { Layout as RaLayout } from 'react-admin';
import { useNavigate } from 'react-router';

import { TaskNotification } from '../Resources/admin';

import { Menu } from './Menu';
import { Routes } from './Routes';

import type { LayoutProps } from 'react-admin';

export const Layout = (props: LayoutProps): React.ReactElement => {
  const navigate = useNavigate();

  // Stable reference: react-admin's Layout uses `appBar` as a component type, so a
  // fresh function identity on every render remounts AppBar and wipes UserMenu's open state.
  const renderAppBar = useCallback(
    () => (
      <AppBar
        userMenu={
          <Box display='flex' alignItems='center' gap={1}>
            <TaskNotification />
            <UserMenu>
              <UserMenuItem
                onClick={() => {
                  void navigate(Routes.settings);
                }}
                label='ord.settings.title'
                icon={<SettingsRounded />}
              />
            </UserMenu>
          </Box>
        }
      />
    ),
    [navigate]
  );

  return (
    <>
      <AnalyticsIdentityBridge />
      <AnalyticsPageTrackingBridge />
      <RaLayout {...props} appBar={renderAppBar} menu={Menu} />
    </>
  );
};
